import React from "react";
import { Check } from "lucide-react";
import "@/styles/finish-line.css";

const BITS = Array.from({ length: 14 }, (_, i) => {
  const a = (i / 14) * Math.PI * 2 + 0.3;
  const d = 62 + (i % 3) * 16;
  return { x: Math.cos(a) * d, y: Math.sin(a) * d * 0.85, r: (i * 47) % 180, c: ["#0055FF", "#34D399", "#7DA9FF", "#FFFFFF"][i % 4], w: i % 2 ? 6 : 4 };
});

/** The finish line: a tick that draws itself, one soft burst, then the reference and what happens next. */
export function FinishLine({ reference, copied, onCopy, steps, children }) {
  return (
    <div className="fl" data-testid="apply-finish-line">
      <div className="fl-medal" aria-hidden="true">
        <span className="fl-glow" />
        {BITS.map((b, i) => (
          <i key={i} className="fl-bit" style={{ "--x": `${b.x}px`, "--y": `${b.y}px`, "--r": `${b.r}deg`, background: b.c, width: b.w, height: b.w * 1.6, animationDelay: `${0.55 + (i % 4) * 0.03}s` }} />
        ))}
        <svg viewBox="0 0 88 88" className="fl-svg">
          <circle cx="44" cy="44" r="40" className="fl-ring" />
          <path d="M28 45.5l10.5 10.5L60 34.5" className="fl-tick" />
        </svg>
      </div>

      <div className="fl-ref fl-rise" style={{ animationDelay: ".7s" }}>
        <div className="fl-ref-k">Your reference</div>
        <div className="fl-ref-row">
          <span className="fl-ref-v" data-testid="apply-reference">{reference}</span>
          <button type="button" onClick={onCopy} className="fl-copy" data-testid="apply-reference-copy">{copied ? "Copied" : "Copy"}</button>
        </div>
      </div>

      <ol className="fl-steps" data-testid="apply-next-steps">
        {steps.map((s, i) => (
          <li key={s.title} className={`fl-step fl-rise${i === 0 ? " is-done" : ""}`} style={{ animationDelay: `${0.85 + i * 0.12}s` }}>
            <span className="fl-dot">{i === 0 ? <Check strokeWidth={3.2} /> : i + 1}</span>
            <div><b>{s.title}</b><small>{s.sub}</small></div>
          </li>
        ))}
      </ol>
      <div className="fl-rise" style={{ animationDelay: "1.25s" }}>{children}</div>
    </div>
  );
}
